import { Spinner } from 'baseui/spinner';
import { RefreshSVG } from 'common/assets';
// import { BASE_PATH } from 'common/constants';
import stylesColors from 'common/styles/styles.colors';
import { SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import {
  ErrorViewContainer,
  // ErrorImageContainer,
  ErrorContentContainer,
  ErrorActionContainer,
  // ErrorImage,
  ErrorSpan,
  RefreshContainer,
} from './styles';
import Text from './text';

interface Props {
  isLoading?: boolean;
  title?: string;
  subtitle?: string;
  refetch?: () => void;
  vertical?: boolean;
}

export default function ErrorViewComponent(props: Props) {
  const { t } = useTranslation();
  const { isLoading, vertical = false, refetch } = props;

  return (
    <ErrorViewContainer
      onClick={() => {
        if (!isLoading) {
          refetch && refetch();
        }
      }}
      vertical={vertical ? 1 : 0}
    >
      {/* <ErrorImageContainer>
        <ErrorImage src={`${BASE_PATH}/assets/folder.png`} alt="img" />
      </ErrorImageContainer> */}
      <ErrorContentContainer vertical={vertical ? 1 : 0}>
        <Text variant="body2Bold">{t('common:load_failed_title')}</Text>
        <SeparatorVertical $margin={8} />
        <ErrorSpan>{t('common:load_failed_message')}</ErrorSpan>
      </ErrorContentContainer>
      <ErrorActionContainer>
        {isLoading ? (
          <Spinner $size={vertical ? 40 : 30} />
        ) : (
          <RefreshContainer>
            <RefreshSVG
              width={vertical ? 40 : 30}
              height={vertical ? 40 : 30}
              color={stylesColors.primaryDefault}
            />
          </RefreshContainer>
        )}
      </ErrorActionContainer>
    </ErrorViewContainer>
  );
}
